export default __webpack_public_path__ + "static/media/1950.b38550b1.png";